module.exports = require('./helpers/bundle-url').getBundleURL('8aiQJ') + "galaGifCircle.9538c6a3.gif";